import type { IModelConnection } from "@itwin/core-frontend";
import { QueryBinder, QueryRowFormat } from "@itwin/core-common";
import type { ElementProps } from "../../domain/elements/Element";

const ECSQL_BASE_ELEMENT = `
  SELECT
    e.Model.Id                  AS Model,
    e.LastMod                   AS LastMod,
    e.CodeSpec.Id               AS CodeSpec,     -- use Id instead of .Name
    e.CodeScope.Id              AS CodeScope,    -- same idea here
    e.CodeValue                 AS CodeValue,
    e.UserLabel                 AS UserLabel,
    e.Parent.Id                 AS Parent,
    GuidToStr(e.FederationGuid) AS FederationGUID,
    e.JsonProperties            AS JSONProperties
  FROM bis.Element e
  WHERE e.ECInstanceId = ?
`;


// Return the raw props that subclasses (Electric, Lighting, etc.) will pass into super(...)
export async function queryBaseElementProps(
  iModel: IModelConnection,
  elementId: string
): Promise<ElementProps | undefined> {
  const bindings = QueryBinder.from([elementId]);

  const reader = iModel.createQueryReader(
    ECSQL_BASE_ELEMENT,
    bindings,
    { rowFormat: QueryRowFormat.UseECSqlPropertyNames } // so aliases match property names
  );

  for await (const row of reader) {
    const r = (row as any).toRow?.() ?? row;

    const result: ElementProps = {
      Model: r.Model,
      // normalize LastMod into a Date
      LastMod: r.LastMod instanceof Date ? r.LastMod : new Date(r.LastMod),
      CodeSpec: r.CodeSpec ?? "",
      CodeScope: r.CodeScope ?? "",
      CodeValue: r.CodeValue ?? "",
      UserLabel: r.UserLabel ?? "",
      Parent: r.Parent ?? "",
      FederationGUID: r.FederationGUID ?? "",
      JSONProperties: r.JSONProperties ?? "",
    };

    return result;
  }

  return undefined;
}
